import qrcode from 'qrcode-generator';

/**
 * A URL, drawn.
 *
 * The one piece of the overlay that is not allowed to be atmospheric: a
 * camera has to read it from across a desk, so the card is light, the modules
 * are solid, and the quiet zone is the full four modules the specification
 * asks for. Everything else in Isidora is warm ink on night; this is the
 * exception, and it earns it by working.
 */

const QUIET = 4;

/**
 * @param {string} text usually an http(s) address; ASCII only
 * @returns {{ svg: string, modules: number }}
 */
export function qrSvg(text) {
  // 0 asks the library for the smallest version the data fits in. M survives
  // a thumb over a corner of the screen, which is how this gets scanned.
  const qr = qrcode(0, 'M');
  qr.addData(text);
  qr.make();

  const n = qr.getModuleCount();
  const side = n + QUIET * 2;

  // One path for the whole code. Each dark module is its own closed subpath,
  // which is both smaller than a rect per module and faster to raster.
  let d = '';
  for (let row = 0; row < n; row++) {
    for (let col = 0; col < n; col++) {
      if (qr.isDark(row, col)) d += `M${col + QUIET} ${row + QUIET}h1v1h-1z`;
    }
  }

  const svg =
    `<svg class="share__qr" viewBox="0 0 ${side} ${side}" ` +
    `shape-rendering="crispEdges" aria-hidden="true">` +
    `<rect width="${side}" height="${side}" fill="#f3ead9"/>` +
    `<path d="${d}" fill="#140f07"/>` +
    `</svg>`;

  return { svg, modules: n };
}
